import { render, staticRenderFns } from "./mistributorManagement.vue?vue&type=template&id=b62a1404&scoped=true&"
import script from "./mistributorManagement.vue?vue&type=script&lang=js&"
export * from "./mistributorManagement.vue?vue&type=script&lang=js&"
import style0 from "./mistributorManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62a1404",
  null
  
)

component.options.__file = "mistributorManagement.vue"
export default component.exports